"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _DataStore = _interopRequireDefault(require("../KESI2/Stores/DataStore2"));

var _HttpRequest = require("./HttpRequest");

var _config = _interopRequireDefault(require("../../targets/cord_eurofh_teams/config.js"));

var _BuildConstants = require("./BuildConstants");

// eslint-disable-line
var DataStoreAblyHelper = /*#__PURE__*/function () {
  function DataStoreAblyHelper() {
    (0, _classCallCheck2["default"])(this, DataStoreAblyHelper);
  }

  (0, _createClass2["default"])(DataStoreAblyHelper, null, [{
    key: "_deleteData",
    value: function () {
      var _deleteData2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(data) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!data.path) {
                  _context.next = 4;
                  break;
                }

                console.log("received remote deletion data message for path \"".concat(data.path, "\""));
                _context.next = 4;
                return _DataStore["default"].removeData(data.path);

              case 4:
                return _context.abrupt("return", _promise["default"].resolve());

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function _deleteData(_x) {
        return _deleteData2.apply(this, arguments);
      }

      return _deleteData;
    }()
  }, {
    key: "_getData",
    value: function () {
      var _getData2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(data) {
        var value, path;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(data.path && data.callbackId)) {
                  _context2.next = 15;
                  break;
                }

                console.log("receive remote get request for data with path \"".concat(data.path, "\" (id: ").concat(data.callbackId, ")"));
                _context2.prev = 2;
                value = _DataStore["default"].getElementByPath(data.path);
                path = "".concat(_BuildConstants.HOST).concat(_config["default"].ablyDataSendUrl);
                _context2.next = 7;
                return (0, _HttpRequest.httpPostJsonEncoded)(path, {
                  callbackId: data.callbackId,
                  path: data.path,
                  value: value || null
                });

              case 7:
                console.log("successfully sent data for request with id ".concat(data.callbackId));
                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](2);
                console.error("Couldn't send data with path \"".concat(data.path, "\" to server:"), _context2.t0);

              case 13:
                _context2.next = 16;
                break;

              case 15:
                console.error('path or callbackId missing in ably GET request for DataStore');

              case 16:
                return _context2.abrupt("return", _promise["default"].resolve());

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 10]]);
      }));

      function _getData(_x2) {
        return _getData2.apply(this, arguments);
      }

      return _getData;
    }()
  }, {
    key: "_setData",
    value: function () {
      var _setData2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(data) {
        var persistent;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!data.path) {
                  _context3.next = 13;
                  break;
                }

                console.log("received remote data message for path \"".concat(data.path, "\": ").concat((0, _stringify["default"])(data.value || null)));
                persistent = 'persistent' in data ? data.persistent : true;
                _context3.prev = 3;
                _context3.next = 6;
                return _DataStore["default"].setSingleData(data.path, data.value === undefined ? null : data.value, persistent);

              case 6:
                _context3.next = 8;
                return DataStoreAblyHelper._getData(data);

              case 8:
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3["catch"](3);
                console.error("Couldn't save or send data with path \"".concat(data.path, "\" to server:"), _context3.t0);

              case 13:
                return _context3.abrupt("return", _promise["default"].resolve());

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[3, 10]]);
      }));

      function _setData(_x3) {
        return _setData2.apply(this, arguments);
      }

      return _setData;
    }()
    /**
     * Handles incoming ably message whose message matches one of DataStoreAblyHelper.MAPPING
     * @param message { {name: string, data: null|{} } }
     * @returns {boolean} true if handled, false if not
     */

  }, {
    key: "handleAblyMessage",
    value: function () {
      var _handleAblyMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(message) {
        var command, data;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!message) {
                  _context4.next = 9;
                  break;
                }

                command = message.name;

                if (typeof message.data === 'string') {
                  console.warn('did not expect message.data to be a string but handling it anyway', message);
                }

                data = typeof message.data === 'string' ? JSON.parse(message.data) : message.data;

                if (!(command in DataStoreAblyHelper.MAPPING)) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 7;
                return DataStoreAblyHelper.MAPPING[command](data);

              case 7:
                return _context4.abrupt("return", _promise["default"].resolve(true));

              case 8:
                return _context4.abrupt("return", _promise["default"].resolve(false));

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function handleAblyMessage(_x4) {
        return _handleAblyMessage.apply(this, arguments);
      }

      return handleAblyMessage;
    }()
  }]);
  return DataStoreAblyHelper;
}();

DataStoreAblyHelper.MAPPING = {
  deleteData: DataStoreAblyHelper._deleteData,
  getData: DataStoreAblyHelper._getData,
  setData: DataStoreAblyHelper._setData
};
var _default = DataStoreAblyHelper;
exports["default"] = _default;